import { Link as RouterDomLink } from "react-router-dom";

import { Link } from "ui/link/link";

import { CustomLinkType } from "ui/custom-link/custom-link.types";

export const CustomLink = ({ className, to = "", label }: CustomLinkType) => {
  return (
    <Link component={RouterDomLink} to={to} className={className} size="small" underline="hover">
      {label}
    </Link>
  );
};
